const gasFlowData = {
    "0.5": [0.01, 0.02, 0.02, 0.03, 0.03, 0.03, 0.04, 0.05, 0.06, 0.07, 0.08, 0.10, 0.11],
    "0.6": [0.02, 0.03, 0.03, 0.04, 0.04, 0.05, 0.05, 0.06, 0.06, 0.07, 0.08, 0.09, 0.10],
    "0.7": [0.03, 0.04, 0.04, 0.05, 0.05, 0.06, 0.06, 0.07, 0.07, 0.08, 0.09, 0.10, 0.12],
    "0.8": [0.04, 0.05, 0.05, 0.06, 0.06, 0.07, 0.07, 0.08, 0.09, 0.10, 0.10, 0.11, 0.12],
    "0.9": [0.05, 0.06, 0.07, 0.08, 0.08, 0.09, 0.09, 0.10, 0.11, 0.12, 0.13, 0.14, 0.15],
    "1.0": [0.06, 0.07, 0.08, 0.09, 0.09, 0.10, 0.11, 0.12, 0.13, 0.14, 0.15, 0.16, 0.18],
    "1.1": [0.07, 0.09, 0.10, 0.11, 0.11, 0.12, 0.13, 0.14, 0.15, 0.16, 0.17, 0.18, 0.21],
    "1.2": [0.08, 0.10, 0.11, 0.12, 0.13, 0.14, 0.15, 0.16, 0.17, 0.19, 0.20, 0.22, 0.24],
    "1.3": [0.10, 0.12, 0.14, 0.16, 0.17, 0.19, 0.20, 0.21, 0.23, 0.26, 0.30, 0.33, 0.37],
    "1.4": [0.12, 0.14, 0.16, 0.18, 0.20, 0.21, 0.23, 0.25, 0.27, 0.30, 0.34, 0.39, 0.44],
    "1.5": [0.14, 0.17, 0.19, 0.21, 0.23, 0.25, 0.27, 0.30, 0.34, 0.39, 0.44, 0.50, 0.57],
    "1.6": [0.15, 0.18, 0.21, 0.24, 0.26, 0.28, 0.30, 0.34, 0.39, 0.44, 0.50, 0.57, 0.65],
    "1.7": [0.17, 0.21, 0.24, 0.27, 0.30, 0.32, 0.34, 0.38, 0.43, 0.48, 0.55, 0.62, 0.70],
    "1.8": [0.19, 0.23, 0.26, 0.30, 0.33, 0.36, 0.38, 0.43, 0.48, 0.54, 0.61, 0.69, 0.78],
    "1.9": [0.21, 0.25, 0.29, 0.33, 0.36, 0.39, 0.43, 0.48, 0.54, 0.60, 0.67, 0.75, 0.84],
    "2.0": [0.24, 0.28, 0.32, 0.36, 0.40, 0.44, 0.48, 0.53, 0.59, 0.66, 0.74, 0.82, 0.91],
    "2.5": [0.37, 0.45, 0.52, 0.60, 0.64, 0.70, 0.76, 0.84, 0.92, 0.99, 1.06, 1.18, 1.30],
    "3.0": [0.53, 0.65, 0.75, 0.88, 0.94, 1.02, 1.10, 1.19, 1.28, 1.37, 1.48, 1.63, 1.80],
    "3.5": [0.72, 0.88, 1.02, 1.14, 1.26, 1.36, 1.48, 1.53, 1.61, 1.77, 1.91, 2.09, 2.30],
    "4.0": [0.94, 1.15, 1.33, 1.40, 1.63, 1.76, 1.88, 2.00, 2.23, 2.40, 2.63, 2.91, 3.16],
    "4.5": [1.19, 1.46, 1.69, 1.88, 2.06, 2.23, 2.43, 2.66, 2.92, 3.16, 3.40, 3.74, 4.00],
    "5.0": [1.47, 1.80, 2.08, 2.33, 2.56, 2.75, 2.92, 3.18, 3.48, 3.74, 3.98, 4.40, 4.80],
    "6.0": [2.12, 2.59, 3.00, 3.35, 3.67, 3.96, 4.24, 4.49, 4.84, 5.18, 5.63, 6.24, 6.70],
    "7.0": [2.88, 3.53, 4.08, 4.66, 4.99, 5.39, 5.77, 6.12, 6.45, 7.06, 7.65, 8.50, 9.08],
    "8.0": [3.77, 4.61, 5.38, 6.02, 6.62, 7.07, 7.53, 8.04, 8.66, 9.22, 9.86, 11.12, 12.02],
    "9.0": [4.77, 5.88, 6.77, 7.45, 8.08, 8.66, 9.22, 9.75, 10.27, 11.20, 12.12, 13.60, 15.00],
    "10.0": [5.88, 7.21, 8.32, 9.30, 10.19, 11.01, 11.77, 12.48, 13.16, 14.41, 15.63, 17.60, 18.92],
    "12.0": [7.12, 8.72, 10.07, 11.26, 12.33, 13.42, 14.65, 15.92, 17.44, 18.92, 20.85, 23.74, 25.83],
    "13.0": [7.94, 9.94, 12.18, 14.06, 15.72, 17.22, 18.89, 20.11, 22.24, 24.36, 26.45, 30.04, 33.05],
    "15.0": [9.94, 12.18, 14.70, 17.00, 19.03, 21.07, 23.08, 24.77, 27.06, 29.77, 33.23, 37.84, 41.32],
    "16.0": [10.66, 13.04, 15.71, 18.17, 20.28, 22.44, 24.77, 26.78, 29.68, 32.78, 36.32, 41.09, 45.42],
    "17.0": [12.18, 14.90, 18.04, 20.85, 23.04, 25.45, 28.04, 30.14, 33.84, 37.84, 42.71, 48.39, 53.53],
    "18.0": [14.10, 17.23, 20.65, 24.05, 26.89, 29.82, 32.47, 35.08, 39.46, 42.83, 48.66, 55.11, 60.58],
    "19.0": [15.41, 18.82, 22.59, 26.31, 29.48, 32.83, 36.27, 39.08, 43.32, 47.73, 54.26, 61.57, 68.50],
    "20.0": [16.80, 20.54, 24.88, 29.57, 33.57, 37.28, 41.03, 44.02, 48.84, 54.26, 61.74, 69.91, 78.02],
    "21.0": [18.22, 22.21, 26.81, 32.06, 36.45, 40.34, 44.91, 48.79, 54.26, 60.48, 68.16, 77.22, 86.70],
    "22.0": [19.68, 23.93, 28.97, 34.60, 39.47, 43.51, 48.78, 53.29, 59.66, 66.60, 74.67, 84.92, 94.87],
    "23.0": [21.21, 25.72, 31.30, 37.26, 42.62, 46.82, 52.82, 57.83, 65.24, 73.38, 81.89, 92.92, 103.46],
    "24.0": [22.68, 27.42, 33.41, 39.67, 45.30, 49.73, 56.16, 61.50, 69.97, 78.96, 88.36, 100.18, 112.27],
    "25.0": [24.16, 29.19, 35.62, 42.28, 48.24, 52.88, 59.66, 65.34, 74.68, 84.46, 94.60, 106.21, 121.20]
};

const gasPressures = [2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14, 16, 18];

function calculateGasFlow() {
    const jetDiameter = document.getElementById('jet-diameter').value;
    const gasPressure = parseFloat(document.getElementById('gas-pressure').value);
    const resultElement = document.getElementById('result-gas-flow');

    if (isNaN(gasPressure)) {
        resultElement.innerText = 'Please enter a valid gas pressure.';
        return;
    }

    const pressureIndex = gasPressures.indexOf(gasPressure);
    if (pressureIndex === -1) {
        resultElement.innerText = 'Gas pressure not found in table. Please use a round number.';
        return;
    }

    const gasFlow = gasFlowData[jetDiameter][pressureIndex];
    resultElement.innerText = `The gas flow is ${gasFlow.toFixed(2)} C.M.H.`;
}

// Make the calculateGasFlow function globally accessible
window.calculateGasFlow = calculateGasFlow;